import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataService } from '../shared/services/data.service';
import { TranslateDirective } from '../shared/translate.directive';
import { LicenceApplicationService } from '../shared/services/licence-application.service';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../shared/services/loader.service';
import { MatIconModule } from '@angular/material/icon';
import { CheckPriceModel, VehiclePriceModel } from '../shared/interfaces/vehicleModel';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerLocComponent } from '../mat-datepicker-loc/mat-datepicker-loc.component';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LoginService } from '../shared/services/login.service';


@Component({
  selector: 'app-application-details',
  standalone: true,
  imports: [FormsModule, TranslateDirective, CommonModule, RouterModule, MatIconModule, MatOptionModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatDatepickerLocComponent, MatIconModule],
  templateUrl: './application-details.component.html',
  styleUrl: './application-details.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationDetailsComponent {
  constructor(private router: Router, private dataService: DataService, private licenceService: LicenceApplicationService,
    private activatedRoute: ActivatedRoute, public myLoaderService: LoaderService , private loginService :LoginService) {
    activatedRoute.queryParams.subscribe((params) => {
      this.id = params['id']
    });
  }

  id: any;
  canExtend: any = false;
  appModel: any = {
    Name: '',
    Months: 1,
    DateSelected: Date,
    Vehicles: [],
    TrafficLicences: [],
    IdFiles: [],
    DriversLicences: [],
    AdditionalFiles: []

  }

  vehicles: CheckPriceModel = {
    Vehicles: [],
    AllowNewCar: true,
    PermitTypeId: 0,
    TotalAmount: 0
  }

  model: any = {


  }
  dateExpiered: any;
  dateTo: any;
  today = new Date();
  // selectedMonth: number = 1;
  selectedMonth: any;
  invalidMonthNumber: boolean = false;
  monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  months = [
    { "Id": "01.09.2025", "Name": "September" },
    { "Id": "01.10.2025", "Name": "October" },
    { "Id": "01.11.2025", "Name": "November" },
    { "Id": "01.12.2025", "Name": "December" },
    { "Id": "01.01.2026", "Name": "January" },
    { "Id": "01.02.2026", "Name": "February" },
    { "Id": "01.03.2026", "Name": "March" },
    { "Id": "01.04.2026", "Name": "April" },
    { "Id": "01.05.2026", "Name": "May" },
    { "Id": "01.06.2026", "Name": "June" },
    { "Id": "01.07.2026", "Name": "July" },
    { "Id": "01.08.2026", "Name": "August" }
  ]
  isAdmin:boolean=false;

  @ViewChild('datepickerFrom') datepickerFrom: MatDatepickerLocComponent | undefined;
  ngOnInit() {
       this.isAdmin = this.loginService.isAdmin();
    this.getApplicationDetalis();
    // this.appModel = this.dataService.getData();
  }

  getApplicationDetalis() {
    this.model.Id = this.id;
    this.licenceService.getApplicationDetalis(this.model).subscribe((res: any) => {
      this.appModel = res;

      this.appModel.IdFiles.forEach((dl: { Path: string; }) => {
        let normalized = dl.Path.replace(/\\/g, "/");
        dl.Path = normalized.replace(/\.(?=[^.]*$)/, "/");
      });
      this.appModel.TrafficLicences.forEach((dl: { Path: string; }) => {
        let normalized = dl.Path.replace(/\\/g, "/");
        dl.Path = normalized.replace(/\.(?=[^.]*$)/, "/");
      });
      this.appModel.DriversLicences.forEach((dl: { Path: string; }) => {
        let normalized = dl.Path.replace(/\\/g, "/");
        dl.Path = normalized.replace(/\.(?=[^.]*$)/, "/");
      });
      this.appModel.AdditionalFiles.forEach((dl: { Path: string; }) => {
        let normalized = dl.Path.replace(/\\/g, "/");
        dl.Path = normalized.replace(/\.(?=[^.]*$)/, "/");
      });
      this.appModel.Months = 1;
      this.model.Vehicles = res.Vehicles;
      const today = new Date(new Date().setHours(0, 0, 0, 0));
      const inThirtyDays = new Date();
      inThirtyDays.setDate(today.getDate() + 30);
      this.dataService.setData(res);
      this.checkPrice();
      this.calculateTotal();
      
      const DateApproved = new Date(this.appModel.DateApproved);
      if (this.appModel.DateApproved != null) {
        this.dateExpiered = new Date(this.appModel.DateApproved)
        this.dateExpiered = new Date(
          this.dateExpiered.getFullYear() + 1,
          this.dateExpiered.getMonth(),
          this.dateExpiered.getDate() - 1
        );
      }
      this.months = this.getNext12Months(DateApproved)
      DateApproved.setFullYear(DateApproved.getFullYear() + 1);
      if (DateApproved >= today && DateApproved <= inThirtyDays) {
        this.canExtend = true;
      }
      if (this.appModel.DurationType == 2 && this.appModel.PaymentTypeId == 2) {
        const today = new Date();
        const currentId = `01.${(today.getMonth() + 1).toString().padStart(2, '0')}.${ today.getFullYear()}`;
        const current = this.months.find(m => m.Id === currentId);
        this.selectedMonth = current ? current.Id : this.months[0].Id;
        this.onMonthChange(this.selectedMonth)
      }
      else if (this.appModel.DurationType == 2 && this.appModel.PaymentTypeId == 1) {
        this.appModel.DateSelected = new Date();
      }
      else if (this.appModel.DurationType == 1) {
        this.appModel.DateSelected = new Date();
        this.dateTo = new Date(
          this.appModel.DateSelected.getFullYear() + 1,
          this.appModel.DateSelected.getMonth(),
          this.appModel.DateSelected.getDate() - 1
        );
      }
      else {
        this.appModel.DateSelected = new Date();

      }
    })
  }


  pay() {
    if (this.appModel.Months > 12 || this.appModel.Months < 1) {
      this.invalidMonthNumber = true;
    }
    else {
      this.router.navigate(['confirm-payment'],
        {
          queryParams: { id: this.id },
          state: { data: this.model }
        });
    }
  }

  extend() {
    this.router.navigate(['licence-application'], {
      queryParams: { id: this.appModel.ApplicationId },
      state: { data: this.appModel }
    });

  }

  goBack() {
    this.router.navigate(['app-list']);
  }

  errorsMessages: any;
  hasErrors: any;
  checkPrice() {
    this.appModel.Vehicles.forEach((vehicle: any) => {
      this.vehicles.Vehicles.push(vehicle);
    });
    this.vehicles.PermitTypeId = this.appModel.PermitTypeId;
    this.licenceService.checkPriceModel(this.vehicles).subscribe(res => {
      this.errorsMessages = null;
      this.appModel.Vehicles = res.Vehicles;
      this.appModel.Price = res.TotalAmount;

      this.appModel.Vehicles.forEach((vehicle: { Id: number; }) => {
        this.selectedVehicleIds.add(vehicle.Id);
      });

    },
      error => {

        this.hasErrors = true;
        this.errorsMessages = error.error.errors[0].Errors[0];
      })
  }

  selectedVehicleIds = new Set<number>();
  totalPrice = 0;

  calculateTotal() {
    this.invalidMonthNumber = false;
    this.appModel.Price = this.appModel.Vehicles
      .filter((car: { Id: number; }) => this.selectedVehicleIds.has(car.Id))
      .reduce((sum: any, car: { Price: any; }) => sum + (car.Price || 0), 0);
    this.appModel.Price = this.appModel.Price * this.appModel.Months;
  }

  toggleSelection(vehicleId: number, checked: boolean) {
    if (checked) {
      this.selectedVehicleIds.add(vehicleId);
    } else {
      this.selectedVehicleIds.delete(vehicleId);
    }
    this.calculateTotal();
  }

  trackByCar(index: number, car: any) {
    return car.VehicleId;
  }
  onMonthChange(month: any) {
    const parts = month.split(".");
    const d = new Date(+parts[2], +parts[1] - 1, +parts[0])
    const date = new Date(Date.UTC(+parts[2], +parts[1] - 1, +parts[0], 0, 0, 0));
    this.appModel.DateSelected = date;
    this.dataService.setData(this.appModel);
  }
  onDateSelectedFrom(date: Date) {
    this.appModel.DateSelected = date
    this.dataService.setData(this.appModel);
  }


  getNext12Months(startDate: Date) {
    const months: { Id: string, Name: string }[] = [];
    let year = startDate.getFullYear();
    let month = startDate.getMonth();

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    for (let i = 0; i < 12; i++) {
      const firstDay = new Date(year, month, 1);
      const day = '01';
      const monthStr = (firstDay.getMonth() + 1).toString().padStart(2, '0');
      const yearStr = firstDay.getFullYear();

      months.push({
        Id: `${day}.${monthStr}.${yearStr}`,
        Name: monthNames[firstDay.getMonth()]
      });

      month++;
      if (month > 11) {
        month = 0;
        year++;
      }
    }

    return months;
  }
}
